import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ServiceLevelAgreementServiceCategoryDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.Price = ko.observable();
    self.DialogViewModel.Amount = ko.observable();
    self.DialogViewModel.TotalPrice = ko.observable();
    self.DialogViewModel.ActivityUnitName = ko.observable();
    self.DialogViewModel.RealAmount = ko.observable(false);
    self.DialogViewModel.SelectedServiceCategory = ko.observable();
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.ServiceCategoryId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Show = function (serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        tabPage.IsLoading(true);
        Bao.post("ServiceLevelAgreementTab/ShowServiceLevelAgreementServiceCategoryDialog", JSON.stringify({
            sessionTabId: parent.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementServiceCategoryId: serviceLevelAgreementServiceCategoryId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.DialogViewModel.Price.subscribe(function () {
        self.CalcuateTotalPrice();
    });
    self.DialogViewModel.Amount.subscribe(function () {
        self.CalcuateTotalPrice();
    });
    self.CalcuateTotalPrice = function () {
        if (self.DialogViewModel.Price() != null && self.DialogViewModel.Amount() != null) {
            self.DialogViewModel.TotalPrice(self.DialogViewModel.Price() * self.DialogViewModel.Amount());
        }
        else {
            self.DialogViewModel.TotalPrice(null);
        }
    };
    self.DialogViewModel.ServiceCategoryDeleted = function () {
        self.DialogViewModel.SelectedServiceCategory(null);
    };
    self.DialogViewModel.SelectedServiceCategory.subscribe(function (item) {
        if (item != null) {
            self.DialogViewModel.ActivityUnitName(item.ActivityUnitName);
            self.DialogViewModel.RealAmount(item.RealAmount);
            self.DialogViewModel.ServiceProviderName(item.ServiceProviderName);
            self.DialogViewModel.ExecutingServiceProviderName(item.ExecutingServiceProviderName);
            self.DialogViewModel.ServiceCategoryName(item.ServiceCategory);
            self.DialogViewModel.ActivityNumber(item.ActivityNumber);
            self.DialogViewModel.Price(item.Price);
        }
        else {
            self.DialogViewModel.ActivityUnitName("");
            self.DialogViewModel.RealAmount(null);
            self.DialogViewModel.ServiceProviderName("");
            self.DialogViewModel.ExecutingServiceProviderName("");
            self.DialogViewModel.ServiceCategoryName("");
            self.DialogViewModel.ActivityNumber("");
            self.DialogViewModel.Price(null);
        }
    });
    self.DialogViewModel.RealAmount.subscribe(function () {
        if (self.DialogViewModel.RealAmount() != null && self.DialogViewModel.RealAmount() == true) {
            self.DialogViewModel.Amount(1);
        }
    });
}
export default ServiceLevelAgreementServiceCategoryDialog;